import { render, staticRenderFns } from "./CompensationList.vue?vue&type=template&id=5e88b648&scoped=true"
import script from "./CompensationList.vue?vue&type=script&lang=js"
export * from "./CompensationList.vue?vue&type=script&lang=js"
import style0 from "./CompensationList.vue?vue&type=style&index=0&id=5e88b648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e88b648",
  null
  
)

export default component.exports